import { Backdrop, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useCallback } from 'react';
import ImagePreview from '../../../f5/ImagePreview';
import { AttachFile, Delete, Publish, Save } from '@material-ui/icons';
import { Field, Ordem, Setor } from './ObraOrderIndex';
import { KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import sweetAlert from '../../../f5/utils/sweetAlert';
import axios_instance from '../../../services/auth/jwt/config';
import FieldInput from '../../../@jumbo/components/Common/FieldInput';
import { useSelector } from 'react-redux';

interface DialogEditOrdemProps {
    open: boolean,
    onClose: () => void,
    editing: Ordem,
    onChange: (e: Ordem) => void,
    mode: 'add' | 'edit' | 'view',
    tipos: any[],
    tecnicos: any[],
    entradas: any[],
    onSave: () => void,
    status: any[],
    anexos: any[],
    onChangeAnexos: (e: any) => void,
    tecnicoPrincipal: any,
    setTecnicoPrincipal: any,
    tecnicosAuxiliares: any,
    setTecnicosAuxiliares: any,
    fields?: Field[],
    setor?: Setor,
    isTerceiro?: boolean,
}

export default function DialogEditOrdem({
    mode, editing, onChange, onClose, open, tipos, tecnicos, onSave, status, anexos, onChangeAnexos,
    tecnicoPrincipal, setTecnicoPrincipal, tecnicosAuxiliares, setTecnicosAuxiliares, entradas,
    fields = [], setor, isTerceiro = false,
    ...props }: DialogEditOrdemProps) {
    const [loading, setLoading] = React.useState({ is: false, message: '' })
    const theme = useTheme()
    const small = useMediaQuery(theme.breakpoints.down('sm'))
    const anexoInput = React.createRef<HTMLInputElement>()
    const auth = useSelector(({ auth }: any) => (auth.authUser ? auth.authUser.cargo.interno : null));

    const isTerceirizada = Boolean(
        isTerceiro ||
        editing?.empresa_id ||
        editing?.empresa ||
        editing?.terceiro ||
        editing?.is_terceiro ||
        editing?.terceirizado
    );

    const onDeleteImage = (id: string) => {
        setLoading({ is: true, message: 'Removendo anexo...' })
        axios_instance.delete<{ success: true, message: string }>(`obra/ordem_servico/anexo/delete/${id}`).then(res => {
            if (res.data.success) {
                onClose()
                sweetAlert('success', 'Sucesso!', res.data.message)
                return
            } else {
                sweetAlert('error', 'Erro!', res.data.message)
                return
            }
        }).catch(() => {
            sweetAlert('error', 'Erro!', 'Erro ao remover anexo')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }

    const isAllowedType = useCallback((file: File) => {
        // allow image, pdf, doc, docx
        if (
            file.type.indexOf('image') === -1 &&
            file.type.indexOf('application/pdf') === -1 &&
            file.type.indexOf('application/msword') === -1 &&
            file.type.indexOf('application/vnd.openxmlformats-officedocument.wordprocessingml.document') === -1
        ) {
            return false
        }
        return true
    }, [])

    const onDownload = useCallback((uuid: string, nome: string) => {
        setLoading({ is: true, message: 'Baixando anexo...' })
        fetch(`https://ribasdigital.cidadeinteligente.app.br/api/obra/ordem_servico/anexo/${uuid}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.blob()).then(blob => {
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = `${nome}`
            a.click()
            a.remove()
            URL.revokeObjectURL(url)
        }).catch(err => {
            sweetAlert('error', 'Erro!', 'Erro ao baixar anexo')
        }).finally(() => {
            setLoading({ is: false, message: '' })
        })
    }, [])

    return <Dialog open={open} onClose={() => onClose()} maxWidth="lg" fullWidth fullScreen={small} style={{ zIndex: 1103 }}>
        <Backdrop open={loading.is} style={{ zIndex: 1105 }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%" color="white">
                <CircularProgress />
                <Typography variant="h6" style={{ marginLeft: 10 }}>{loading.message}</Typography>
            </Box>
        </Backdrop>
        <DialogTitle>
            {mode === 'add' ? 'Adicionar' : 'Editar'} Ordem de Serviço
        </DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                {setor?.hide_fields?.solicitante ? null : <Grid item xs={12} md={6}>
                    <TextField
                        label="Nome do Solicitante"
                        fullWidth
                        required
                        variant="outlined"
                        value={editing.solicitante}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, solicitante: e.target.value })}
                    />
                </Grid>}
                {setor?.hide_fields?.local ? null : <Grid item xs={12} md={6}>
                    <TextField
                        label="Local"
                        fullWidth
                        required
                        variant="outlined"
                        value={editing.local}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, local: e.target.value })}
                    />
                </Grid>}
                {setor?.hide_fields?.telefone ? null : <Grid item xs={12} md={6}>
                    <TextField
                        label="Telefone"
                        fullWidth
                        variant="outlined"
                        value={editing.telefone}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, telefone: e.target.value })}
                    />
                </Grid>}
                {setor?.hide_fields?.celular ? null : <Grid item xs={12} md={6}>
                    <TextField
                        label="Celular"
                        fullWidth
                        variant="outlined"
                        value={editing.celular}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, celular: e.target.value })}
                    />
                </Grid>}
                {setor?.hide_fields?.endereco ? null : <Grid item xs={12} md={6}>
                    <TextField
                        label="Endereço"
                        fullWidth
                        required
                        variant="outlined"
                        value={editing.endereco}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, endereco: e.target.value })}
                    />
                </Grid>}
                <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth required>
                        <InputLabel required>{setor?.translate?.tipo ?? "Tipo de Serviço"}</InputLabel>
                        <Select
                            value={editing.tipo_id}
                            //@ts-ignore
                            onChange={(e) => onChange({ ...editing, tipo_id: e.target.value })}
                            label={setor?.translate?.tipo ?? "Tipo de Serviço"}
                            required
                            disabled={mode === 'view'}
                        >
                            {tipos.map((t, index) => (
                                <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {setor?.hide_fields?.entrada ? null : <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>{setor?.translate?.entrada ?? "Entrada"}</InputLabel>
                        <Select
                            value={editing.entrada_id}
                            //@ts-ignore
                            onChange={(e) => onChange({ ...editing, entrada_id: e.target.value })}
                            label={setor?.translate?.entrada ?? "Entrada"}
                            required
                            disabled={mode === 'view'}
                        >
                            {entradas.map((t, index) => (
                                <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>}
                {mode !== 'add' && editing?.prazo ? <Grid item xs={12} md={6}>
                    <TextField
                        label="Prazo"
                        fullWidth
                        variant="outlined"
                        value={moment(editing.prazo).format('DD/MM/YYYY')}
                        disabled={true}
                    />
                </Grid> : null}
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Protocolo"
                        fullWidth
                        variant="outlined"
                        disabled={true}
                        value={editing.protocolo}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth required>
                        <InputLabel required>{setor?.translate?.responsavel ?? "Técnico Responsável"}</InputLabel>
                        <Select
                            value={tecnicoPrincipal}
                            required
                            //@ts-ignore
                            onChange={(e) => setTecnicoPrincipal(e.target.value)}
                            label={setor?.translate?.responsavel ?? "Técnico Responsável"}
                            disabled={mode === 'view'}
                        >
                            {tecnicos.map((t, index) => (
                                <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>{setor?.translate?.auxiliar ?? "Técnicos Auxiliares"}</InputLabel>
                        <Select
                            multiple
                            value={tecnicosAuxiliares}
                            //@ts-ignore
                            onChange={(e) => setTecnicosAuxiliares(e.target.value)}
                            label={setor?.translate?.auxiliar ?? "Técnicos Auxiliares"}
                            disabled={mode === 'view'}
                        >
                            {tecnicos.map((t, index) => (
                                <MenuItem key={index} value={t.id}>{t.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Descrição"
                        fullWidth
                        variant="outlined"
                        multiline
                        required
                        minRows={3}
                        disabled={(mode === 'edit' && auth === 'obras_tecnico') || mode === 'view'}
                        value={editing.descricao}
                        onChange={(e) => onChange({ ...editing, descricao: e.target.value })}
                    />
                </Grid>
                {fields?.map((field, index) => <Grid item xs={12} md={field.size} key={field.slug}>
                    <FieldInput
                        field={field}
                        value={editing?.data?.[field.slug]}
                        onChange={(value) => onChange({ ...editing, data: { ...editing?.data, [field.slug]: value } })}
                    />
                </Grid>)}
                {mode !== 'add' ? <Grid item xs={12}>
                    <TextField
                        label="Intervenção"
                        fullWidth
                        variant="outlined"
                        multiline
                        minRows={3}
                        value={editing.intervencao}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, intervencao: e.target.value })}
                    />
                </Grid> : null}
                {mode !== 'add' ? <Grid item xs={12} md={6}>
                    <TextField
                        label={setor?.translate?.materiais ?? "Materiais e Equipamentos"}
                        fullWidth
                        variant="outlined"
                        multiline
                        minRows={3}
                        value={editing.materiais_equipamentos}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, materiais_equipamentos: e.target.value })}
                    />
                </Grid> : null}
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Observação"
                        fullWidth
                        multiline
                        variant="outlined"
                        minRows={3}
                        value={editing.observacao}
                        disabled={mode === 'view'}
                        onChange={(e) => onChange({ ...editing, observacao: e.target.value })}
                    />
                </Grid>
                {mode !== 'add' ? <Grid item xs={12} md={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={editing.status_id}
                            //@ts-ignore
                            onChange={(e) => onChange({ ...editing, status_id: e.target.value })}
                            label="Status"
                            disabled={mode === 'view'}
                        >
                            {status.map((s, index) => (
                                <MenuItem key={index} value={s.id}>{s.nome}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid> : null}
                {mode === 'add' ? <Grid item xs={12} md={6}>
                    <KeyboardDatePicker
                        label="Data de Abertura"
                        format="DD/MM/yyyy"
                        variant="inline"
                        inputVariant="outlined"
                        fullWidth
                        value={moment(editing.created_at)}
                        onChange={(date) => onChange({ ...editing, created_at: date?.format('YYYY-MM-DD') ?? '' })}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </Grid> : null}
                {isTerceirizada ? <>
                    <Grid item xs={12} md={4}>
                        <KeyboardDateTimePicker
                            label="Data e Hora de Início"
                            format="DD/MM/YYYY HH:mm"
                            variant="inline"
                            inputVariant="outlined"
                            fullWidth
                            ampm={false}
                            disabled={mode === 'view' || !editing.comeco_at}
                            value={editing.comeco_at ? moment(editing.comeco_at) : null}
                            onChange={(date) => onChange({ ...editing, comeco_at: date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null })}
                            KeyboardButtonProps={{
                                'aria-label': 'alterar data e hora de início',
                            }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!editing.comeco_at}
                                    disabled={mode === 'view'}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            onChange({ ...editing, comeco_at: null });
                                        } else {
                                            onChange({ ...editing, comeco_at: moment().format('YYYY-MM-DD HH:mm:ss') });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="Desabilitar"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <KeyboardDateTimePicker
                            label="Data e Hora de Término"
                            format="DD/MM/YYYY HH:mm"
                            variant="inline"
                            inputVariant="outlined"
                            fullWidth
                            ampm={false}
                            disabled={mode === 'view' || !editing.termino_at}
                            value={editing.termino_at ? moment(editing.termino_at) : null}
                            onChange={(date) => onChange({ ...editing, termino_at: date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null })}
                            KeyboardButtonProps={{
                                'aria-label': 'alterar data e hora de término',
                            }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!editing.termino_at}
                                    disabled={mode === 'view'}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            onChange({ ...editing, termino_at: null });
                                        } else {
                                            onChange({ ...editing, termino_at: moment().format('YYYY-MM-DD HH:mm:ss') });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="Desabilitar"
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <KeyboardDateTimePicker
                            label="Data e Hora de Finalização"
                            format="DD/MM/YYYY HH:mm"
                            variant="inline"
                            inputVariant="outlined"
                            fullWidth
                            ampm={false}
                            disabled={mode === 'view' || !editing.finalizado_at}
                            value={editing.finalizado_at ? moment(editing.finalizado_at) : null}
                            onChange={(date) => onChange({ ...editing, finalizado_at: date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null })}
                            KeyboardButtonProps={{
                                'aria-label': 'alterar data e hora de finalização',
                            }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={!editing.finalizado_at}
                                    disabled={mode === 'view'}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            onChange({ ...editing, finalizado_at: null });
                                        } else {
                                            onChange({ ...editing, finalizado_at: moment().format('YYYY-MM-DD HH:mm:ss') });
                                        }
                                    }}
                                    color="primary"
                                />
                            }
                            label="Desabilitar"
                        />
                    </Grid>
                </> : null}
                {editing?.anexos?.map((anexo: any, index: number) => <Grid item xs={12} md={2}>
                    <Box border="1px solid grey" flexDirection="column" bgcolor="#fefefe" borderRadius={5} position="relative" display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                        {anexo.type == 'image' ? <ImagePreview
                            url={`https://ribasdigital.cidadeinteligente.app.br/api/obra/ordem_servico/anexo/${anexo.uuid}`}
                            label={`Anexo ${index + 1} - ${editing.protocolo}`}
                        /> : <Box
                            display="flex" width="100%" flexDirection="column" justifyContent="center" alignItems="center" height="100%" px={2}
                            onClick={() => onDownload(anexo.uuid, anexo.nome)} style={{ cursor: 'pointer' }}
                        >
                            <AttachFile style={{ fontSize: 50, color: '#4caf50' }} />
                            <Typography style={{ width: '100%' }} noWrap align='center' >{anexo.nome}</Typography>
                        </Box>}
                        <Delete
                            style={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5, color: 'red' }}
                            onClick={() => {
                                sweetAlert('danger', 'Deletar anexo!', 'Tem certeza que deseja excluir o anexo?', () => {
                                    onDeleteImage(anexo.uuid)
                                })
                            }}
                        />
                    </Box>
                </Grid>)}
                {mode !== 'view' ? <>
                    {anexos.map((anexo, index) => <Grid item xs={12} md={2}>
                        <Box border="1px solid grey" flexDirection="column" bgcolor="#fefefe" borderRadius={5} position="relative" display="flex" justifyContent="center" alignItems="center" minHeight={100}>
                            {anexo.type.indexOf('image') !== -1 ? <img
                                src={URL.createObjectURL(anexo)} style={{ maxWidth: '100%', maxHeight: 100 }}
                            /> : <Box display="flex" width="100%" flexDirection="column" justifyContent="center" alignItems="center" height="100%" px={2}>
                                <AttachFile style={{ fontSize: 50, color: '#4caf50' }} />
                                <Typography style={{ width: '100%' }} noWrap align='center' >{anexo.name}</Typography>
                            </Box>}
                            <Delete
                                style={{ cursor: 'pointer', position: 'absolute', top: 5, right: 5, color: 'red' }}
                                onClick={() => onChangeAnexos(anexos.filter((a, i) => i !== index))}
                            />
                        </Box>
                    </Grid>)}
                    <Grid item xs={12} md={2}>
                        <Box
                            border="2px dashed grey" flexDirection="column" bgcolor="#fefefe" borderRadius={5} display="flex" justifyContent="center" alignItems="center" minHeight={100} style={{ cursor: 'pointer' }}
                            onClick={() => {
                                if (anexoInput.current) {
                                    anexoInput.current.click()
                                }
                            }}
                            onDragOver={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                            }}
                            onDrop={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                // block no image files
                                for (let i = 0; i < e.dataTransfer.files.length; i++) {
                                    if (!isAllowedType(e.dataTransfer.files[i])) {
                                        alert('Apenas imagens, pdf, doc e docx são permitidos')
                                        return
                                    }
                                }
                                onChangeAnexos([...anexos, ...Array.from(e.dataTransfer.files)])
                            }}
                        >
                            <Publish />
                            <Typography>Adicionar anexo</Typography>
                            <input
                                ref={anexoInput} type="file" style={{ display: 'none' }} accept='image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                                multiple={true}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    if (!e.target.files) return
                                    for (let i = 0; i < e.target.files.length; i++) {
                                        if (!isAllowedType(e.target.files[i])) {
                                            alert('Apenas imagens, pdf, doc e docx são permitidos')
                                            return
                                        }
                                    }
                                    onChangeAnexos([...anexos, ...Array.from(e.target.files)])
                                }}
                            />
                        </Box>
                    </Grid>
                </> : null}
            </Grid>
        </DialogContent>
        <DialogActions>
            <Box display="flex" justifyContent="space-between" width="100%">
                <Button variant="contained" color="secondary" onClick={() => onClose()}>Cancelar</Button>
                {mode === 'view' ? null : <Button
                    variant="contained"
                    startIcon={<Save />}
                    style={{ backgroundColor: '#4caf50', color: 'white' }} onClick={onSave}
                >
                    Salvar
                </Button>}
            </Box>
        </DialogActions>
    </Dialog >
}